export default __webpack_public_path__ + "static/wishbone-b5eba8cbd2aa89704388ffb5512b7d4a.png";